import { render } from "./UserForm.vue?vue&type=template&id=6f387e10&scoped=true&ts=true"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"

import "./UserForm.vue?vue&type=style&index=0&id=6f387e10&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f387e10"]])

export default __exports__